import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/Login'
import Register from '@/pages/Register'
import FindPass from '@/pages/FindPass'
import Dash from '@/pages/Dash'
import BasicInfo from '@/pages/BasicInfo'
import Questionnaire from '@/pages/Questionnaire'
import Confirmation from '@/pages/Confirmation'
import GroupRegister from '@/pages/GroupRegister'
import AddMember from '@/pages/AddMember'
import HelpRegister from '@/pages/HelpRegister'
import AddEmployee from '@/pages/AddEmployee'
import InviteOpera from '@/pages/InviteOpera'
import Meeting from '@/pages/Meeting'
import ChangePassword from '@/pages/ChangePassword'
import NotFound from '@/pages/NotFound'
import Close from '@/pages/Close'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/findPass',
      name: 'FindPass',
      component: FindPass
    },
    {
      path: '/close',
      name: 'Close',
      component: Close
    },
    {
      path: '/',
      component: Dash,
      children: [
        {
          path: 'basicInfo',
          alias: '',
          component: BasicInfo,
          // meta: { requiresAuth: true },
          name: 'BasicInfo'
        },
        {
          path: 'questionnaire',
          component: Questionnaire,
          // meta: { requiresAuth: true },
          name: 'Questionnaire'
        },
        {
          path: 'confirmation',
          component: Confirmation,
          // meta: { requiresAuth: true },
          name: 'Confirmation'
        },
        {
          path: 'groupRegister',
          component: GroupRegister,
          // meta: { requiresAuth: true },
          name: 'GroupRegister'
        },
        {
          path: 'addMember',
          component: AddMember,
          // meta: { requiresAuth: true },
          name: 'AddMember'
        },
        {
          path: 'helpRegister',
          component: HelpRegister,
          // meta: { requiresAuth: true },
          name: 'HelpRegister'
        },
        {
          path: 'inviteOpera',
          name: 'InviteOpera',
          component: InviteOpera
        },
        {
          path: 'addEmployee',
          component: AddEmployee,
          // meta: { requiresAuth: true },
          name: 'AddEmployee'
        },
        {
          path: 'changePassword',
          component: ChangePassword,
          // meta: { requiresAuth: true },
          name: 'ChangePassword'
        },
        {
          path: 'meeting',
          // meta: { requiresAuth: true },
          component: Meeting,
          name: 'Meeting'
        }
      ]
    },
    {
      // not found handler
      path: '*',
      component: NotFound
    }
  ],
  mode: 'hash'
})



// WEBPACK FOOTER //
// ./src/router/index.js